import { FC } from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  fullHeight?: boolean;
  className?: string;
}

const sizeClasses = {
  small: 'h-6 w-6 border-2',
  medium: 'h-12 w-12 border-2',
  large: 'h-16 w-16 border-3'
} as const;

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  fullHeight = true,
  className = ''
}) => {
  return (
    <div className={`flex justify-center items-center ${fullHeight ? 'h-[60vh]' : ''} ${className}`}>
      <div 
        className={`
          animate-spin rounded-full
          border-t-blue-500 border-r-transparent
          border-b-blue-500 border-l-transparent
          ${sizeClasses[size as keyof typeof sizeClasses]}
          transition-all duration-200
        `}
      />
      <span className="sr-only">Carregando...</span>
    </div>
  );
};

export default LoadingSpinner;
